import { time } from "@/utils/time"
import axios, { AxiosError } from 'axios'
import { appUrl } from '@/utils/app_url'

let accessToken: string | undefined
async function login<T>(cb: (credentials: {}) => T) {
  while (true) {
    try {
      accessToken = (await getAccessToken()).access_token
      return await cb({ authenticity_token: accessToken, source_origin: location.origin })
      // @ts-ignore
    } catch (e: any) {
      if (e.response) {
        const response = e.response as AxiosError["response"]
        if (response!.status === 401) {
          accessToken = undefined
          continue
        }
      }
      throw JSON.stringify(e)
    }
  }
}

async function getAccessToken() {
  if (accessToken !== undefined) {
    return { access_token: accessToken }
  }
  let sleep = 100
  for (let i = 0; i < 5; ++i) {
    try {
      // tslint:disable-next-line:max-line-length
      const { data } = await axios.get<{ access_token: string }>(`/datasearch/skymaps_api/session/access_token?source_origin=${encodeURIComponent(location.origin)}`)
      return data
    } catch (e) {
      // In Safari, pushing iframe of authorized page into the document,
      // allows ajax access for the page without credentials.
      await new Promise<void>(async (resolve) => {
        const iframe = document.createElement('iframe')
        iframe.src = appUrl('/datasearch/')
        document.body.appendChild(iframe)
        await time.sleep(sleep *= 2)
        resolve()
        document.body.removeChild(iframe)
      })
    }
  }
  throw new Error(`Cannot get access token for CAS`)
}

export const database = {
  login,
}
